import { Injectable } from '@angular/core';
import { AppTokenHandler } from './app-token-handler';
import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { Observable, catchError, map, of, throwError } from 'rxjs';
import { GlobalVariable } from '../Variable/global-variable';

@Injectable({ providedIn: 'root' })
export class LoginService {
  public redirectUrl: string | null = null;

  constructor(
    private appToken: AppTokenHandler,
    private http: HttpClient,
    private router: Router,
    private activeRoute: ActivatedRoute,
    private gVariable: GlobalVariable,
  ) {}

  login(azureToken: string = ''): Observable<any> {
    const dummyEmail = sessionStorage.getItem('dummyEmail');
    const url = dummyEmail ? `/?email=${dummyEmail}` : '';

    const tokenpath = `${environment.tokenPath}Login/UserDetailAndToken${url}`;

    const headers = {
      headers: new HttpHeaders({
        azure_token: this.appToken.getAzureTokenFromLocalStorage(),
        'Content-Type': 'application/json',
      }),
      withCredentials: true,
    };
    return this.http.get(tokenpath, headers).pipe(catchError(this.handleError));
  }

  getUserDetails() {
    this.login().subscribe({
      next: (data: any) => {
        if (data) {
            this.SetSessionAndNavigate(data, null);
        } else {
          this.router.navigate(['unauthorize']);
        }
      },
      error: (error: any) => {
        if (error.status <= 0) {
          this.router.navigate(['badrequest']);
      }
      else if (error.status == 401) {
          this.router.navigate(['unauthorize']);
      }
      else {
        this.router.navigate(['badrequest']);
      }
      },
    });
  }
  SetSessionAndNavigate(loginData: any, expectedRole: any) {
    this.appToken.setSessionToken(loginData);
    sessionStorage.setItem('userToken', loginData.TokenID);
                sessionStorage.setItem('userDetails', JSON.stringify(loginData));
                this.gVariable.userToken = loginData.TokenID;
    this.setGlobalVariableḍValue();
    this.activeRoute.queryParams.subscribe(() => {

      const redirectUrl = sessionStorage.getItem('redirectUrl');

      if (this.redirectUrl === null && redirectUrl && redirectUrl.length > 0) {
        this.redirectUrl = redirectUrl;
      }

      if (!this.redirectUrl) {
        this.router.navigate(['/INFTE/home']);
      } else {
        sessionStorage.setItem('redirectUrl', '');
        this.router.navigate([this.redirectUrl]);
        this.redirectUrl = null;
      }
    });
  }

  setGlobalVariableḍValue() {
    this.gVariable.userToken = sessionStorage.getItem('userToken');
  }
  
  private handleError(error: HttpErrorResponse) {
    let errorMessage = 'An unknown error occurred!';
    if (error.error instanceof ErrorEvent) {
      errorMessage = `An error occurred: ${error.error.message}`;
    } else {
      errorMessage = `Server returned code: ${error.status}, error message is: ${error.message}`;
    }
    console.error(errorMessage);
    return throwError(() => new Error(errorMessage));
  }
}
